<template>
	<div>

		<!--Header-->
		<page-title :divider="true"
					icon="accreditation"
					info="Create and manage your Accreditation Events."
					title="Accreditation"/>

		<div class="d-flex justify-center mt-4">
			<div class="d-flex flex-column align-center" style="width: 960px">

				<app-text size="large-bold">MEDIA ACCREDITATION</app-text>

				<app-text class="text-center mt-4">
					Welcome to the Media Accreditation procedure for WALES HOME FIXTURES AT PRINCIPALITY STADIUM
				</app-text>

				<ul>
					<li class="mt-4">
						<app-text>
							️Please note the deadline for media accreditation is 10 working days prior to match day
							(unless otherwise stated) Requests made after the deadline will not be accepted
						</app-text>
					</li>
					<li class="mt-4">
						<app-text>
							All photographers, written media and non-rights holders must apply through this portal
						</app-text>
					</li>
					<li class="mt-4">
						<app-text>
							Please note ALL photographers must read the <span @click="openPdf" class="text-decoration-underline primary--text" style="cursor: pointer;">Photographers Agreement</span>. By clicking to accept
							T&Cs you are bound by the regulations within the agreement.
						</app-text>
					</li>
				</ul>
				<app-text class="mt-4">
					If you have any questions at this stage please contact Anna Chapman <span><a href="mailto:achapman@wru.wales">achapman@wru.wales</a></span>
				</app-text>

				<!--Terms & Conditions-->
				<form-section-title class="mt-4" title="Terms & Conditions"/>
				<div class="appWhite rounded-lg pa-4" style="height: 224px; overflow: auto; width: 100%">
					<h3>WRU Accreditation Portal Media and Photographer T&Cs</h3>
					<div class="mt-4" v-html="generalMediaContent"/>
					<div class="mt-8" v-html="photographersContent"/>
				</div>

				<!--Checkbox | Continue Button-->
				<div class="d-flex justify-space-between mt-4" style="width: 100%">

					<!--Checkbox-->
					<div class="d-flex align-center">
						<div @click="handleCheckboxSelection"
							 class="appWhite d-flex align-center justify-center rounded-lg mr-4"
							 style="height: 56px; width: 56px">
							<app-icon color="green"
									  :icon="hasAcceptedTCs ? 'check' : ''"
									  size="32"/>
						</div>
						<app-text>I accept the Terms & Conditions</app-text>
					</div>

					<!--Continue Button-->
					<app-btn @click.native="handleContinue"
							 color="green"
							 :disabled="!hasAcceptedTCs"
							 icon="success"
							 label="Continue"/>

				</div>

			</div>
		</div>

	</div>
</template>

<script>

import { getStorage, ref, getDownloadURL } from 'firebase/storage'
import { generalMediaContent, photographersContent } from '@/views/termsAndConditions/termsAndConditionsContent'

export default {

	name: "MyAccreditationEventLandingPage",

	props: ['fullEventData'],

	data: () => ({
		hasAcceptedTCs: false,
		generalMediaContent,
		photographersContent,
	}),

	methods: {

		handleCheckboxSelection() {
			const t = this

			t.hasAcceptedTCs = !t.hasAcceptedTCs
		},

		handleContinue() {
			const t = this

			// If the user hasn't accepted the T&Cs, don't continue
			if (!t.hasAcceptedTCs) return

			t.$emit('saveEventTCs', t.$props.fullEventData)
		},

        async openPdf() {
            try {
                // Get reference to the file in Firebase Storage
                const storage = getStorage()
                const pdfRef = ref(storage, 'termsAndConditions/Photographer Agreement 2025.pdf')
                
                // Get the download URL
                const url = await getDownloadURL(pdfRef)
                
                // Open in new tab
                window.open(url, '_blank')
            } catch (error) {
                console.error('Error opening PDF:', error)
            }
        }
	},

}
</script>

<style scoped>

</style>
